<template>
  <router-link
    id="logo"
    to="/call-log">
    <img
      src="../assets/img/logo.png"
    />
  </router-link>
</template>

<script>
export default {
  name: 'PosmLogo',
};
</script>

<style lang="scss"></style>
